import { render, staticRenderFns } from "./PatientSuccessModal.vue?vue&type=template&id=7306ce98&"
import script from "./PatientSuccessModal.vue?vue&type=script&lang=js&"
export * from "./PatientSuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports